module.exports = __webpack_public_path__ + "img/mp3-logo.e63a0cbf.jpg";